import { useEffect, useRef, useState } from "react";

interface StickyScrollButtonProps {
  sectionId: string;
  isLoading: boolean;
  label?: string;
}

export default function StickyScrollButton({ sectionId, isLoading, label }: StickyScrollButtonProps) {
  const [showButton, setShowButton] = useState(false);
  const hasEnteredRef = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    const checkVisibility = () => {
      const section = document.getElementById(sectionId);
      if (!section) return;

      const rect = section.getBoundingClientRect();

      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

      if (isInViewport) {
        hasEnteredRef.current = true;
        setShowButton(false);
      } else {
        if (hasEnteredRef.current && rect.bottom <= 0) {
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      }
    };

    checkVisibility();
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);

    return () => {
      window.removeEventListener("scroll", checkVisibility);
      window.removeEventListener("resize", checkVisibility);
    };
  }, [sectionId, isLoading]);

  const scrollToSection = () => {
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: "smooth",
    });
  };

  if (!showButton) return null;

  return (
    <div className={"fixed !top-auto z-50 bottom-8 right-4 lg:bottom-[60px] lg:right-[calc(((100vw-1340px)/2)-24px)]"}>
      <button
        onClick={scrollToSection}
        className={
          "theme-btn theme-btn-primary rounded-full inline-flex gap-2 px-4 shadow-[0px_4px_20px_0px_rgba(255,130,0,0.75)]"
        }>
        <span className={"uppercase font-semibold text-xs leading-5.5 lg:text-sm"}>{label}</span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={"size-5 lg:size-6 shrink-0"}>
          <g clip-path="url(#clip0_45518_9013)">
            <path
              d="M7 17L12 12L17 17"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M7 11L12 6L17 11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_45518_9013">
              <rect width="24" height="24" fill="white" transform="translate(1.04908e-06 24) rotate(-90)" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  );
}
